import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { fetchHouseList, fetchRemoveHouse, fetchReorderHouse, updateRemoveHouseNo, updateReorderHouse, updateFetchStatusRemove } from '@Root/slices/myhouse/settingSlice'
import { RootState } from '@Root/slices'
import { MyhouseLabelType } from '@Root/utils/houseLabelUtils'
import { FETCH_STATUS } from '@Root/contants'

export default function useSetting() {
  const dispatch = useDispatch()
  const reduxSetting = useSelector((state: RootState) => state.setting)

  const loadRemoveHouse = useCallback(
    (param: { houseNo: number }) => {
      dispatch(fetchRemoveHouse(param))
    },
    [dispatch],
  )

  const loadHouseList = useCallback(() => {
    dispatch(fetchHouseList())
  }, [dispatch])

  const loadReorderHouse = useCallback(
    (param: { myHouseNo: number; myHouseOrder: number }[]) => {
      dispatch(fetchReorderHouse(param))
    },
    [dispatch],
  )

  const setRemoveHouseNo = useCallback(
    (houseNo: number) => {
      dispatch(updateRemoveHouseNo(houseNo))
    },
    [dispatch],
  )

  const setReorderHouse = useCallback(
    (param: MyhouseLabelType[]) => {
      dispatch(updateReorderHouse(param))
    },
    [dispatch],
  )

  const initFetchStatusRemove = useCallback(() => {
    dispatch(updateFetchStatusRemove(FETCH_STATUS.INITIAL))
  }, [dispatch])

  return {
    loadRemoveHouse,
    loadHouseList,
    loadReorderHouse,
    setRemoveHouseNo,
    setReorderHouse,
    reduxSetting,
    initFetchStatusRemove,
  }
}
